import React from 'react';
import { CirclePicker } from 'react-color';

const SelectColor = ({ value, onChange }) => {
  return (
    <div className="gx-selectcolor-container">
      <CirclePicker
        circleSize={30}
        width="100%"
        color={value}
        onChange={({ hex }) => onChange(hex)}
        colors={[
          '#f9e1db',
          '#f56193',
          '#cf7bdd',
          '#b695f1',
          '#c6cfff',
          '#9bcdf5',
          '#9deff9',
          '#b1f7f0',
          '#a9ffad',
          '#fff1c9',
          '#c4d6df'
        ]}
      />
    </div>
  );
};

export default SelectColor;
